// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/TradeType.yaml
// Generated: 2026-07-08T08:07:38.270Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateTradeType, UpdateTradeType, TradeType } from '@/types/core/TradeType';

/**
 * TradeType Service
 * CRUD operations for TradeType via the ABP API.
 */
export const tradeTypeService = new EntityService<TradeType, CreateTradeType, UpdateTradeType>(
  '/api/core/tradetype',
  'TradeType',
);
